import React from "react";
import { Play } from "lucide-react";
import { usePlayer } from "../context/PlayerContext";

const AlbumCard = ({ album, size = "md" }) => {
  const { play, current } = usePlayer();
  const isActive = current?.id === album.id;

  const sizes = {
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg",
  };

  return (
    <button
      onClick={() => play(album)}
      className="group text-left w-full focus:outline-none"
      aria-label={`Play ${album.title}`}
    >
      <div className="relative aspect-square overflow-hidden rounded-md shadow-md bg-neutral-200">
        <img
          src={album.cover}
          alt={album.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent opacity-60 group-hover:opacity-90 transition-opacity" />
        <div
          className={`absolute right-3 bottom-3 w-12 h-12 rounded-full bg-white text-black flex items-center justify-center shadow-xl transform ${
            isActive
              ? "scale-100 opacity-100"
              : "translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100"
          } transition-all duration-300`}
        >
          <Play className="w-5 h-5 ml-0.5" fill="currentColor" />
        </div>
        <span className="absolute top-3 left-3 text-[10px] uppercase tracking-[0.18em] text-white/90 bg-black/40 backdrop-blur px-2 py-1 rounded-full">
          {album.type} · {album.year}
        </span>
      </div>
      <div className="mt-3">
        <h3 className={`font-medium tracking-tight text-black ${sizes[size]}`}>
          {album.title}
        </h3>
        <p className="text-neutral-500 text-sm mt-0.5 line-clamp-1">
          {album.subtitle}
        </p>
      </div>
    </button>
  );
};

export default AlbumCard;
